<script setup>
import {
  AisPanel,
} from 'vue-instantsearch/vue3/es'


</script>

<template>
<AisPanel
  :class-names="{
    'ais-Panel': 'bg-white',
    'ais-Panel--noRefinement': 'hidden',
    'ais-Panel-header': 'font-bold',
    'ais-Panel-body': '',
    'ais-Panel-footer': '',
  }"
  v-bind="$attrs"
>
  <template v-slot:header="{ hasRefinements }">
    <slot name="header" :hasRefinements="hasRefinements"/>
  </template>
  <template v-slot:default="{ hasRefinements }">
    <slot :hasRefineMents="hasRefinements"/>
  </template>
  <template v-slot:footer="{ hasRefinements }">
    <slot name="footer" :hasRefinements="hasRefinements"/>
  </template>
</AisPanel>
</template>

